/**
 * Tutorial guidato delle impostazioni Framework.
 *
 * Un preparativo solo: il riquadro del primo servizio, che il passo dedicato apre
 * per mostrarne i campi. `stopFrameworkTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-framework"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopFrameworkTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createFrameworkTourSteps() {
	return [
		{
			body: "Qui si collegano i negozi costruiti con un'altra piattaforma - Magento, PrestaShop, Shopify - perche' il gestionale possa scambiarci prodotti e ordini. Serve solo a chi ha gia' un negozio altrove: chi usa il sito di AzSeller non ha niente da accendere in questa pagina.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I negozi collegati',
		},
		{
			body: "Una riga per piattaforma, con il suo interruttore. Acceso vuol dire che il gestionale comincia a parlare con quel negozio: prima di accenderlo conviene avere le credenziali pronte, perche' l'interruttore salva subito.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un collegamento',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione di quella piattaforma: indirizzo del negozio e chiavi di accesso, che si generano dal pannello della piattaforma stessa. Ogni riquadro ha il suo Conferma, che salva solo quel servizio.",
			before: stopFrameworkTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Dentro il riquadro ci sono i campi da compilare con quello che la piattaforma ha rilasciato. Un collegamento acceso con credenziali sbagliate non rompe niente, ma riempie i registri di errori e non porta dentro nessun ordine: se qualcosa non arriva, e' il primo posto da guardare.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le credenziali',
		},
	];
}
